import { OTR_MICROWAVES_ANIMATIONS } from './applianceConstants/otr-microwaves';

/* eslint-disable max-len */
export const ONLINE_STORE_ID = '8119';
export const TYPE_LIST = ['PIP', 'PLP', 'MINI'];

export const VALID_APPLIANCE_TYPES = [
  'REFRIGERATOR',
  'FRIDGE',
  'LAUNDRY',
  'WASHER',
  'DRYER',
  'ALL-IN-ONE',
  'RANGE',
  'OTR_MICROWAVES',
  'DISHWASHER',
];

export const WIDGET_MAPPING = {
  REFRIGERATOR: {
    PIP: {
      header: 'Does This Refrigerator Fit Your Space?',
      subtext: 'Measure your space, not your old refrigerator.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find Refrigerators That Fit Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
    FIT: {
      header: 'Hooray! This Refrigerator Fits Your Space',
      subtext: 'this fridge sticks out {depthOverhang} inches from your countertop. This depth is still considered a well-fitted installation.',
      isPip: true
    },
    NO_FIT: {
      header: 'This Refrigerator Doesn\'t Fit Your Space',
      subtext: 'Check your measurements or view other options',
      isPip: true
    }
  },
  LAUNDRY: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find a Washer & Dryer That Fit Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  },
  RANGE: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find a Range That Fits Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  },
  OTR_MICROWAVES: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find an Over-the-Range Microwave That Fits Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  },
  DISHWASHER: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find a Dishwasher That Fits Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  }
};

export const DIMENSIONS = [
  { key: 'width', label: 'Width', placeholder: 'Ex: 36.5', drawerIndex: 2 },
  { key: 'height', label: 'Height', placeholder: 'Ex: 96', drawerIndex: 3 },
  { key: 'depth', label: 'Depth', placeholder: 'Ex: 24', drawerIndex: 4 },
];
export const RECOMMENDED_CLEARANCE = {
  width: 1,
  height: 1,
  depth: 2
};

export const APPLIANCE_FITS = {
  FITS: 'FITS',
  DOES_NOT_FIT: 'DOES_NOT_FIT',
  MOSTLY_FITS: 'MOSTLY_FITS',
  FITS_WITH_OVERFLOW: 'FITS_WITH_OVERFLOW'
};

export const SIXTY_DAYS_IN_MS = 5184000000;
